import z from "zod";

const tinybirdErrorTypeValues = [
  "TINYBIRD_CLIENT_MISCONFIGURED",
  "TINYBIRD_INGESTION_FAILED",
  "TINYBIRD_QUERY_FAILED",
  "TINYBIRD_READ_TOKEN_NOT_CONFIGURED",
  "TINYBIRD_WRITE_TOKEN_NOT_CONFIGURED",
] as const;

const tinybirdErrorTypeSchema = z.enum(tinybirdErrorTypeValues);
const TinybirdErrorType = tinybirdErrorTypeSchema.enum;
type TinybirdErrorType = z.infer<typeof tinybirdErrorTypeSchema>;

type ErrorDetails = {
  sentryDescription: string;
};

export type TinybirdErrors =
  | {
      errorType: typeof TinybirdErrorType.TINYBIRD_CLIENT_MISCONFIGURED;
      data: { baseUrl: string };
    }
  | {
      errorType: typeof TinybirdErrorType.TINYBIRD_INGESTION_FAILED;
      data: { datasource: string; httpStatus?: number; eventCount: number; responseBody?: string };
    }
  | {
      errorType: typeof TinybirdErrorType.TINYBIRD_QUERY_FAILED;
      data: {
        pipe: string;
        httpStatus?: number;
        xDbExceptionCode?: string;
        xRequestId?: string;
        rowValidationErrorPaths?: readonly (readonly (string | number)[])[];
      };
    }
  | {
      errorType: typeof TinybirdErrorType.TINYBIRD_READ_TOKEN_NOT_CONFIGURED;
      data: { pipe: string };
    }
  | {
      errorType: typeof TinybirdErrorType.TINYBIRD_WRITE_TOKEN_NOT_CONFIGURED;
      data: { datasource: string };
    };

export const tinybirdErrorDetails: Record<TinybirdErrorType, ErrorDetails> = {
  [TinybirdErrorType.TINYBIRD_CLIENT_MISCONFIGURED]: {
    sentryDescription: "Tinybird client is misconfigured",
  },
  [TinybirdErrorType.TINYBIRD_INGESTION_FAILED]: {
    sentryDescription: "Tinybird ingestion failed",
  },
  [TinybirdErrorType.TINYBIRD_QUERY_FAILED]: {
    sentryDescription: "Tinybird pipe query failed",
  },
  [TinybirdErrorType.TINYBIRD_READ_TOKEN_NOT_CONFIGURED]: {
    sentryDescription: "Tinybird read token is not configured",
  },
  [TinybirdErrorType.TINYBIRD_WRITE_TOKEN_NOT_CONFIGURED]: {
    sentryDescription: "Tinybird write token is not configured",
  },
};
